import D2C_Tariff from '../Tariff'

class D2C_TariffOption extends D2C_Tariff {
  isOption = true
  static objectType = 'tariffGroup'
  static groupName = 'option'
  static groupTitle = 'Option'
}

export default D2C_TariffOption
